import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { auth } from '../config/fb';
// REDUX
import {
  resetUser,
  setLoginStatus
} from '../redux/user.slice';
import {
  setMode,
  setReset,
  setSentTokenMessage,
  unloadUnityApp,
  setCurrentPage
} from '../redux/app.slice';
import { setNotification } from '../redux/notification.slice';
// API
import { deleteSession, invalidateUserToken } from '../apis/user.api';
import { updateUnityAppLoginStatusApi } from '../apis/app.api';
import { fetchLoginNotificationApi } from '../apis/notification.api';
// Images
import Logo from '../images/lavenir-logo.png';

const UserNav = () => {
  // console.log('UserNav RENDERING');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [isPlaying, setIsPlaying] = useState(true); // eslint-disable-line
  const [org, setOrg] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // const { app, user } = useSelector((state) => ({ ...state })); // eslint-disable-line

  const { unityAppRunning } = useSelector((state) => state.app, shallowEqual);
  const { sentTokenMessage } = useSelector((state) => state.app, shallowEqual);
  const { reactVerbosity } = useSelector((state) => state.app);
  const { mode } = useSelector((state) => state.app, shallowEqual);
  const { currentPage } = useSelector((state) => state.app, shallowEqual);
  const { loginStatus  } = useSelector((state) => state.user, shallowEqual); // eslint-disable-line
  const { role } = useSelector((state) => state.user.user, shallowEqual);
  const { name } = useSelector((state) => state.user.user, shallowEqual);
  const { organization } = useSelector((state) => state.user.user, shallowEqual);
  const { email } = useSelector((state) => state.user.user, shallowEqual);
  const { idToken } = useSelector((state) => state.user.user, shallowEqual);
  const notification = useSelector((state) => state.notification, shallowEqual);

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const res = await fetchLoginNotificationApi(idToken);
        dispatch(setNotification({
          flag: !!res.data.flag,
          message: res.data.message || ''
        }));
      } catch (err) {
        reactVerbosity > 0 && console.log('ERROR FETCHING NOTIFICATION:', err);
      }
    };

    if (loginStatus && idToken) {
      fetchNotification();
    }
  }, [loginStatus, idToken]); // eslint-disable-line

  // useEffect(() => {
  //   console.log('UserNav ==> sentTokenMessage, currentPage:', sentTokenMessage, currentPage)
  // }, [sentTokenMessage, currentPage])

  useEffect(() => {
    const setUserInfo = async () => {
      await setUserName(name);
      await setFirstName(name.split(' ')[0]);
      if (organization.name) {
        await setOrg(organization.name);
      } else {
        await setOrg(organization);
      }
    };

    setTimeout(() => {
      if (typeof name === 'string' && name.length > 0 && organization != null) {
        setUserInfo();
      }
    }, 100);
  }, [name, organization]);

  const handleClickOverlay = () => {
    // TODO: DECIDE TO NOTIFY USER TO WAIT FOR APP TO FINISH LOADING
    // console.log('OVERLAY CLICK')
  };

  const logOutHandler = async () => {
    const application = {userEmail: email, loginStatus: false};
    await updateUnityAppLoginStatusApi(application);
        
    signOut(auth)
      .then(async (res) => {
        // Sign-out successful
        await dispatch(setLoginStatus(false));
        // await dispatch(setEmailVerified(false));
        await dispatch(resetUser());
        await dispatch(setNotification({ flag: false, message: '' }));

        await deleteSession();
        // TODO: clear user session, will need a call to backend..
        setTimeout(() => {
          dispatch(setCurrentPage('login'));
          navigate('/login', { replace: true });
        }, 0);
      })
      .catch((error) => {
        reactVerbosity > 0 && console.log('ERROR SIGNING OUT:', error);
      });
  };

  const navToDash = () => {
    console.log("!!!!navToDash!!!!", role)
    if (role === 'admin') {
      reactVerbosity === 2 && console.log("/admin/dash")
      navigate('/admin/dash', { replace: true });
    } else if (role === 'leader') {
      navigate('/leader/dash', { replace: true });
    } else if (role === 'trainee') {
      navigate('/trainee/dash', { replace: true });
    } else {
      // User that has not been assigned a role
      navigate('/');
    }
  };

  const handleLogoNav = () => {
    if (currentPage !== 'login-entraid') {

      if (!unityAppRunning) {
        reactVerbosity === 2 && console.log('** unity app NOT running **')
        setIsPlaying(false);
        dispatch(setSentTokenMessage(false));
        navigate('/');
      } else {
        reactVerbosity === 2 && console.log('** unity app running, setting unloadUnityApp to true **')
        dispatch(unloadUnityApp(true));
      }

    }
  };

  const handleLoginNav = () => {
    console.log("----> handleLoginNav", unityAppRunning)
      if (!unityAppRunning) {
        console.log("----> handleLoginNav - unityAppRunning is false")
        setIsPlaying(false);
        dispatch(setSentTokenMessage(false));
        dispatch(setReset(true));
        navigate('/login', { replace: true });
        // window.location.replace(`/login`);
      } else {
        console.log("----> handleLoginNav - unityAppRunning is true")
        dispatch(unloadUnityApp(true));
      }

  };
  const handleRegisterNav = async () => {
    console.log("----> handleRegisterNav", unityAppRunning)
    if (!unityAppRunning) {
      console.log("----> handleRegisterNav - unityAppRunning is false")
      await setIsPlaying(false);
      await dispatch(setSentTokenMessage(false));
      await dispatch(setReset(true));
      await navigate('/register', { replace: true });
      // window.location.replace(`/login`);
    } else {
      console.log("----> handleRegisterNav - unityAppRunning is true")
      dispatch(unloadUnityApp(true));
    }
  };

  const invalidateUser = async () => {
    toast.error("Session expired. Please log in again.");
    await dispatch(setSentTokenMessage(false));
    await dispatch(setLoginStatus(false));
    await dispatch(resetUser());
    await dispatch(setNotification({ flag: false, message: '' }));
    await dispatch(setCurrentPage('login'));
    navigate('/login', { replace: true });
  };

  return (
    <>  
      {currentPage !== 'subscribe-new' && currentPage !== 'subscription-update-success' ? 
        <header className="flex justify-between items-center px-3 pr-6 py-4 bg-[#ffffff] text-[#000000]"> 

        {currentPage === 'unityApp' && !sentTokenMessage && (
          <div
            className="absolute inset-0 bg-gray-500 bg-opacity-50 z-10 h-[65px]"
            onClick={handleClickOverlay}
          ></div>
        )}

        <div className="text-2xl font-bold" onClick={() => handleLogoNav()}>
          <img src={Logo} alt="lavenirai" className="h-9 hover:cursor-pointer" />
        </div>
        
        <nav className="flex items-center space-x-8">
          {<div className="text-green-500 hover:text-gray-700 hover:cursor-pointer">{role}</div>}
          {loginStatus && <div className="text-black hover:text-gray-700 hover:cursor-pointer" onClick={() => handleLogoNav()}>Home</div>}
          {currentPage !== 'login-entraid' && <Link to="https://lavenirai.com/support" className="text-black hover:text-gray-700">Contact Support</Link>}
          {!loginStatus && currentPage !== 'login-entraid' && currentPage !== 'register' && currentPage !== 'subscribe'&& (
            <Link className="text-black hover:text-gray-700" onClick={handleRegisterNav}>
                Register
              </Link>
          )}
          {!loginStatus && currentPage === 'register' && (
            <Link className="text-black hover:text-gray-700" to="/login" onClick={handleLoginNav}>
                Login
              </Link>
          )}
          {/* /subscribe is reached without a full login (expired org, inactive seat), so offer the way out there too */}
          {(loginStatus || currentPage === 'subscribe') && currentPage !== 'unityApp' && <div className="relative">
              <button 
                onClick={logOutHandler} 
                className="text-black hover:text-gray-700"
              >
                Log Out
              </button>
            </div>
          }
          {false && loginStatus && currentPage !== 'unityApp' && (
            <div className="relative">
              <button 
                className="text-black hover:text-gray-700"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                onBlur={() => setTimeout(() => setDropdownOpen(false), 100)}
              >
                System Admin <span className="ml-1">▼</span>
              </button>
              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg">
                  <button 
                    onClick={logOutHandler} 
                    className="block w-full text-left px-4 py-2 text-sm text-black hover:bg-gray-100"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          )}
        </nav>
      </header> : <></>}

      {notification.flag && notification.message && (
        <div className="notification-marquee">
          <span className="notification-marquee-track">{notification.message}</span>
        </div>
      )}
    </>
  );
};

export default React.memo(UserNav);
